import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/recursos_humanos/bajaIgss';
import ListBaja from './BajaList';


const ms2p = (state) => {
  return {
    ...state.baja_igss_rh,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(ListBaja);